<template>
    <b-modal size="lg" id="exact_online_manager_modal">
        <template slot="modal-title">Manage general Exact online config</template>
        <v-app class="v-appNoBackground v-app">
            <b-form ref="exact_online_manager_modal_form">
                <b-form-group label="Division number of Exact online administration.">
                    <b-form-input
                            id="ExactDivision"
                            placeholder="845367"
                            :state="isNotNullAndUndefinedAndEmpty(exactOnlineV1Config.division)"
                            v-model="exactOnlineV1Config.division"
                            required/>
                </b-form-group>
                <b-form-group label="The ID for the Warehouse to be used for stock.">
                    <b-form-input
                            id="ExactWarehouseID"
                            placeholder="636bf8cb-c89a-443a-b943-f3b210b2435f"
                            v-model="exactOnlineV1Config.WarehouseCode"/>
                </b-form-group>
                <b-form-group label="The code of the sales journal.">
                    <b-form-input
                            id="ExactJournalCode"
                            placeholder="70"
                            v-model="exactOnlineV1Config.JournalCode"/>
                </b-form-group>
                <hr/>
            </b-form>
            <i>*Makes sure all the field are present, does not validate their value.</i>
        </v-app>
        <template slot="modal-footer">
            <b-button block
                      variant="secondary"
                      @click="forceRerender">
                Check required fields
                <v-icon dark>mdi-file-document-box-search-outline</v-icon>
                *
            </b-button>
            <v-divider vertical/>
            <b-button block
                      variant="primary"
                      @click="save">
                Save config
                <v-icon dark>mdi-content-save-outline</v-icon>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    import ProjectRepository from '../../../repositories/project.repository'

    export default {
        props: {
            projectConfig: {
                type: Object,
                default: () => {
                }
            },
            projectId: {
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                componentKey: 0,
                tempVars: {},
                exactOnlineV1Config: {
                    division: null,
                    WarehouseCode: null,
                    JournalCode: null,
                },
            }
        },
        methods: {
            save() {
                this.forceRerender();
                if (this.$refs.exact_online_manager_modal_form.checkValidity()) {
                    this.projectConfig.exactOnlineV1Config = this.exactOnlineV1Config;
                    this.$emit('show-loading-pop-up', "Saving the project Config");
                    this.$bvModal.hide('exact_online_manager_modal');
                    ProjectRepository.saveProjectConfig(this.projectConfig, this.projectId).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('saved-project-config');
                        this.$bvToast.toast('Successfully saved the project config', {
                            title: `Config save successful.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$bvModal.show('exact_online_manager_modal');
                        console.error(error);
                        this.$bvToast.toast('Looks like something went wrong on the server while saving the project config.', {
                            title: `Config save error.`,
                            variant: 'danger',
                            solid: true
                        });
                    });
                }
            },
            isNotNullAndUndefinedAndEmpty(value) {
                return (value !== undefined && value !== null && value !== "");
            },
            objectKeys(val) {
                return Object.keys(val);
            },
            forceRerender() {
                this.componentKey++;
            }
        },
        watch: {
            projectConfig() {
                if (this.projectConfig.exactOnlineV1Config !== undefined) {
                    this.exactOnlineV1Config = this.projectConfig.exactOnlineV1Config;
                }
            }
        }
    }
</script>

